<template>
  <div>
    <h3 class="section-title mb-2">付加情報</h3>
    <ul class="place-info">
      <li>
        <span>交通種別：</span>
        <span>{{ getTraffic(place.type) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  methods: {
    getTraffic: function (type) {
      switch (type) {
        case "train":
          return "鉄道"
        case "plane":
          return "飛行機"
        case "ship":
          return "船"
        case "bus":
          return "バス"
      }
    }
  }
}
</script>
